/** The file was automatically generated. Please do not modify manually */
import tr from './online.json';
export var strings_tr = tr;
